var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2552 20.0259C39.2552 9.39089 30.6364 0.769531 20.0046 0.769531C9.37274 0.769531 0.753906 9.39089 0.753906 20.0259C0.753906 30.6609 9.37274 39.2822 20.0046 39.2822C30.6364 39.2822 39.2552 30.6609 39.2552 20.0259Z",
    fill: "#FF0209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1744 28.5474C27.6008 28.6096 27.0137 28.6204 26.451 28.6191C22.0614 28.615 17.6718 28.611 13.2835 28.6082C11.9024 28.6082 10.3982 28.5636 9.33086 27.6854C8.12828 26.6936 7.87803 24.9738 7.78064 23.4177C7.64536 21.2851 7.63454 19.1458 7.74547 17.012C7.80634 15.8401 7.9132 14.6399 8.41777 13.5791C8.7803 12.8173 9.38497 12.1326 10.1587 11.7726C11.0583 11.3545 11.9998 11.4289 12.9683 11.4276C15.2869 11.4249 17.6055 11.4235 19.9241 11.4208C22.3346 11.4181 24.7466 11.4168 27.1571 11.4141C28.2961 11.4141 29.519 11.4371 30.4483 12.096C31.6482 12.9458 31.9742 14.5628 32.1243 16.0255C32.4016 18.7196 32.4057 21.4421 32.1352 24.1362C32.0229 25.2471 31.8362 26.4216 31.1044 27.2646C30.3793 28.1008 29.3039 28.4229 28.1757 28.546L28.1744 28.5474Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9226 20.0152L17.3809 16.2373V23.7932L23.9226 20.0152Z",
    fill: "#FF0209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/IconYoutube.7e5eb60d7100002ee3cec9d0dc399f2c.svg";
export { ForwardRef as ReactComponent };